import { createContext } from 'react';

// Plots nested anywhere inside a widget inherit its displayed name.
export default createContext('');
